<template>
  <div class="home">
    <div class="banner">
      <img src="../asset/aike/dbanner.png" alt />
    </div>
    <div id="div1" class="main">
      <!-- <div id="div1" class="t1 wow fadeInUp">{{$t('duty').text0}}</div> -->
      <Honor />
      <div class="allItems wow fadeInUp">
        <div class="item" v-for="(item,index) in data" :key="index">
          <div class="pic">
            <img :src="`http://www.icoolglobal.cn/${item.picurl}`" alt />
          </div>
          <p>{{item.title}}</p>
        </div>
      </div>
      <div class="page wow fadeInUp">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-count="totalPage"
        ></el-pagination>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import Honor from '@/components/honor.vue'
import foot from "@/components/foot.vue";
import Scrollbar from "smooth-scrollbar";
import { getDuty } from "../util/lang";

export default {
  name: "home",
  data() {
    return {
      data: "",
      totalPage: 0,
      scrollbar: "",
      id: "",
    };
  },
  mounted() {
    Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    this.scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
    this.scrollbar.scrollTo(0, 1);
    this.scrollbar.addListener((status) => {
      window.pageYOffset = this.scrollbar.scrollTop;
    });

    this.getContent();
    setTimeout(() => {
      Scrollbar.get(document.getElementById("scroller-wrapper")).scrollIntoView(
        document.querySelector("#div1"),
        {
          offsetTop: 170,
        }
      );
    }, 100);
  },
  components: { foot,Honor },
  methods: {
    getContent(id) {
      this.id = id;
      const url = `${getDuty(1)}`;
      this.$axios.get(url).then((res) => {
        this.data = res.data.duty;
        this.totalPage = res.data.pages;
      });
    },
    handleCurrentChange(val) {
      if (val <= this.totalPage) {
        this.$nextTick(() => {
          const url = `${getDuty(val++)}`;
          this.$axios.get(url).then((res) => {
            this.data.news = res.data.news;
          });
        });
      } else {
        this.$notify({
          title: "Prompt",
          message: "Already Loaded",
          offset: 100,
        });
      }
    },
  },
};
</script>
<style  lang="scss" scoped>
.home {
  width: 100%;
  .banner {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    img {
      width: 100%;
      display: block;
      object-fit: cover;
      height: 100%;
      animation: sbig 5s linear forwards;
    }
    @keyframes sbig {
      from {
        transform: scale(1);
      }
      to {
        transform: scale(1.05);
      }
    }
  }
  .main {
    width: 80%;
    padding: 60px 0;
    margin: 0 auto;
    .t1 {
      width: 100%;
      text-align: center;
      color: #333333;
      font-size: 38px;
      font-family: "SOURCEHANSANSCN-MEDIUM";
    }
    .allItems {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-left: -3%;
      .item {
        width: 29%;
        background: #ffffff;
        padding: 20px 0;
        box-shadow: 0px 2px 12px 0px #dfdfdf;
        margin-left: 3%;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        .pic {
          width: 80%;
          margin: 0 auto;
          // overflow: hidden;
          // z-index: 2;
          img {
            width: 100%;
            display: block;
            object-fit: contain;
            transition: all 600ms;
          }
        }
        p {
          text-align: center;
          color: #666666;
          font-size: 18px;
          margin-top: 40px;
          font-family: "SOURCEHANSANSCN-NORMAL";
          position: relative;
          // background-color: red;
          // z-index: 0;
          &::after {
            display: inline-block;
            content: "";
            position: absolute;
            top: -50px;
            left: 50%;
            transform: translateX(-50%);
            height: 50px;
            width: 1px;
            background-color: #7777775c;
            z-index: -1;
          }
        }
        &:hover {
          .pic {
            z-index: 100;
            img {
              transform: scale(1.1);
            }
          }
        }
      }
    }
    .page {
      text-align: center;
      margin: 60px auto;
    }
  }
  @media screen and (max-width:1000px){
    .main{
      width:90%;
      padding: 30px 0;
      .t1{
        font-size: 24px;
      }
      .allItems{
        margin-left: 0;
        .item{
          width:100%;
          margin: 0;
          margin-top: 30px;
        }
      }
    }
  }
}
</style>
<style scoped>
.swiper-pagination {
  position: absolute;
  width: 100%;
  display: flex;
  left: 0;
  bottom: 0;
  justify-content: center;
  flex-direction: row;
}
.swiper-pagination >>> .swiper-pagination-bullet {
  margin: 0 10px;
  width: 12px;
  height: 12px;
  border: 1px solid rgba(12, 78, 162, 1);
  border-radius: 50%;
  background-color: transparent;
  outline: none;
  transition: all 600ms;
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color: #0c4ea2;
}
</style>
